module.exports = __webpack_public_path__ + "img/an_icon_has_been_used@2x.13f1e87b.png";